import {StepLabel, styled} from '@mui/material';

export const Container = styled(StepLabel)`
	align-items: start;
	width: 100%;

	.MuiStepLabel-label {
		justify-content: space-between;
		align-items: center;
		display: flex;
	}

	.MuiStepLabel-iconContainer {
		padding-right: 16px;
	}

	.MuiStepIcon-root {
		height: 28px;
		width: 28px;
	}

	.Mui-disabled .MuiStepIcon-root circle {
		stroke: ${({theme}) => theme.palette.text.disabled};
		stroke-width: 1px;
		fill: none;
		r: 11;
	}

	.Mui-disabled .MuiStepIcon-text {
		fill: ${({theme}) => theme.palette.text.disabled};
	}

	.MuiStepIcon-text {
		font-size: 0.875rem;
		font-weight: 600;
	}

	.MuiStepLabel-labelContainer {
		width: 100%;
		color: ${({theme}) => theme.palette.text.disabled};
	}
`;
